import {
  GET_REPORTS,
  PROPOSAL_BY_SELLER,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  SEARCH_ASSOCIATES,
} from './actionType';

const INIT_STATE = {
  reports: null,
  reportsBySeller: {},
  reportsSearchAssociates: {},
  error: {},
  success: '',
};

const Reports = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_REPORTS:
          return {
            ...state,
            reports: action.payload.data,
            success: '',
            error: {},
          };
        case PROPOSAL_BY_SELLER:
          return {
            ...state,
            reportsBySeller: action.payload.data,
            success: '',
            error: {},
          };
        case SEARCH_ASSOCIATES:
          return {
            ...state,
            reportsSearchAssociates: action.payload.data,
            success: '',
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_REPORTS:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case PROPOSAL_BY_SELLER:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        case SEARCH_ASSOCIATES:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_REPORTS: {
      return {
        ...state,
      };
    }
    case PROPOSAL_BY_SELLER: {
      return {
        ...state,
        reportsBySeller: {},
      };
    }

    case SEARCH_ASSOCIATES: {
      return {
        ...state,
        reportsSearchAssociates: {},
      };
    }

    default:
      return { ...state };
  }
};

export default Reports;
